'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = Overlay;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SpruceClassName = require('stampy/lib/util/SpruceClassName');

var _SpruceClassName2 = _interopRequireDefault(_SpruceClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Overlay(props) {
    var children = props.children,
        className = props.className,
        modifier = props.modifier,
        _props$spruceName = props.spruceName,
        name = _props$spruceName === undefined ? 'Overlay' : _props$spruceName,
        parent = props.parent,
        _props$element = props.element,
        Component = _props$element === undefined ? 'div' : _props$element,
        otherProps = (0, _objectWithoutProperties3.default)(props, ['children', 'className', 'modifier', 'spruceName', 'parent', 'element']);


    var parentClassName = (0, _SpruceClassName2.default)({ className: className, modifier: modifier, parent: parent, name: name });

    return _react2.default.createElement(
        Component,
        (0, _extends3.default)({ className: parentClassName }, otherProps),
        _react2.default.createElement(
            'div',
            { className: name + '_content' },
            children
        )
    );
}


//////////////////
// WEBPACK FOOTER
// ./~/react-goose/lib/Overlay.js
// module id = 116
// module chunks = 35783957827783 114276838955818 162898551421021